export default "__VITE_ASSET__a031f03e__"